import PropTypes from 'prop-types'
import React from 'react'
import { Icon } from '@paypalcorp/pp-react'
import styles from './gift-options.styles'
import { css } from 'lib/paypalphrodite'
import { GIFT_OPTIONS } from '../../constants'
import GiftEntry from './gift-entry'
import { expandGiftOptions } from '../../../experiments/gift-options'
import { trackLink } from '../../../lib/analytics/fpti'
import content from 'pp-react-l10n'

let i18n = content('transfer/themes')
const isDefaultExpand = expandGiftOptions()

class GiftOptions extends React.Component {
  static propTypes = {
    handleChangeGiftOption: PropTypes.func.isRequired,
    giftOption: PropTypes.string,
    pageName: PropTypes.string,
    pageGroup: PropTypes.string,
  }

  static defaultProps = {
    giftOption: '',
  }

  state = {
    isExpanded: isDefaultExpand,
    icon: isDefaultExpand ? 'chevron-up' : 'chevron-down',
  }

  toggleDetails = () => {
    const { pageGroup, pageName } = this.props
    trackLink('send_money_as_a_gift', pageGroup, pageName, 'link')
    this.setState(prevState => ({
      isExpanded: !prevState.isExpanded,
      icon: prevState.isExpanded ? 'chevron-down' : 'chevron-up',
    }))
  }

  handleToggleOnKeyPress = event => {
    if (event.keyCode === 32) {
      this.toggleDetails(event)
    }
  }

  handleGiftOptionClick = newGiftOption => {
    this.props.handleChangeGiftOption(newGiftOption)
  }

  render() {
    const { giftOption } = this.props

    return (
      <div className={css(styles.wrapper)}>
        <span
          role="button"
          tabIndex="0"
          className={css(styles.headerText)}
          onClick={this.toggleDetails}
          onKeyUp={this.handleToggleOnKeyPress}
        >
          {i18n('giftOptions.header')}
          <Icon name={this.state.icon} className={css(styles.chevronIcon)} />
        </span>
        {this.state.isExpanded && (
          <React.Fragment>
            <GiftEntry
              giftOption={GIFT_OPTIONS.ecard}
              handleChangeGiftOption={this.handleGiftOptionClick}
              selectedGiftOption={giftOption}
            />
            <GiftEntry
              giftOption={GIFT_OPTIONS.ppdg}
              handleChangeGiftOption={this.handleGiftOptionClick}
              selectedGiftOption={giftOption}
            />
          </React.Fragment>
        )}
      </div>
    )
  }
}

export default GiftOptions
